import { HttpParams } from "@angular/common/http";
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { DatatableComponent, SelectionType } from "@swimlane/ngx-datatable";
import { NotificationsService } from "angular2-notifications";
import { NgxSpinnerService } from "ngx-spinner";
import { DatatableService } from "../../../services/datatable.service";
import { SpringDatatablePagination } from "../../../services/spring-integration/pagination/spring-datatable-pagination";
import { SpringDatatablePaginationService } from "../../../services/spring-integration/pagination/spring-datatable-pagination.service";
import { getDialogCancel } from "../../utils/get-dialog-cancel";
import { getImportacaoType } from "../../utils/get-importacao-type";
import { ModalErroComponent } from "../modals/modal-erro/modal-erro.component";
import { ModalHelpComponent } from "../modals/modal-help/modal-help.component";
import { EColumnType } from "./EColumnType";
import { EImportacaoType } from "./EImportacaoType";
import { ITableProps } from "./ITableProps";
import { TableService } from "./table.service";

@Component({
  selector: "ngx-dynamic-table",
  templateUrl: "./table.component.html",
  styleUrls: ["./table.component.scss"],
})
export class TableImportacaoComponent implements OnInit, OnDestroy {
  @Input() columns: Array<ITableProps>;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() urlGet: string;
  @Input() params: string;
  @Input() showButton: boolean;
  @Input() buttonText: string;
  @Input() buttonHelpText: string;
  @Input() enumMap: any;
  @Input() enum: any;
  @Input() showHtml: boolean;
  @Input() qtdErros: number;
  @Input() totalRegistros: number;
  @Input() valorTotal: number;
  @Input() tableType: string = "NORMAL";
  @Input() showItemsPerPageSelector: boolean;
  @Input() headerAtivacao: boolean = false;
  @Input() isAtivacao = false;
  @Input() importacaoType: EImportacaoType;

  @Input()
  set filtersValue(value: HttpParams) {
    this.filters = value;
    this.changeFilters();
  }

  get filtersValue(): HttpParams {
    return this.filters;
  }

  @Output() data: Array<any> = [];
  @Output() action: EventEmitter<void> = new EventEmitter();
  @Output() actionView: EventEmitter<any> = new EventEmitter();
  @Output() getSelected: EventEmitter<any[]> = new EventEmitter();
  @Output() actionDownloadError?: EventEmitter<void> = new EventEmitter();

  @ViewChild("myTable", { static: true }) myTable: DatatableComponent;
  @ViewChild("myDetailRow", { static: true }) myDetailRow: TemplateRef<any>;

  public limitArray = [50, 100, 150];
  public customLogin = null;
  public filtersString: string = null;
  public allRowsSelected: boolean = false;
  public selected = [];
  public filters: HttpParams;
  public tableLimit = 15;
  public hasErrors = false;

  public datatablePagination: SpringDatatablePagination =
    new SpringDatatablePagination();
  public EColumnType = EColumnType;
  public SelectionType = SelectionType;

  constructor(
    private datatableService: DatatableService,
    private tableService: TableService,
    private spinnerService: NgxSpinnerService,
    private paginationService: SpringDatatablePaginationService,
    private dialogService: NbDialogService,
    private notificationsService: NotificationsService
  ) {}

  ngOnInit(): void {
    const resCustom = localStorage.getItem("bway-customLogin");
    this.customLogin = JSON.parse(resCustom);

    if (this.showItemsPerPageSelector) {
      this.tableLimit = 50;
    }

    this.spinnerService.show();
    this.datatableService.subscribeTable(this.myTable);
    this.datatablePagination.rowData = [];
    this.datatablePagination.currentPage = 1;
    this.datatablePagination.totalPages = 0;
    this.datatablePagination.totalElements = 0;
    this.datatablePagination.tableLimit = this.tableLimit;
    this.paginationService.setDatatablePagination(this.datatablePagination);
    this.fillData(0);
  }

  ngOnDestroy(): void {
    this.datatableService.unsubscribeTable(this.myTable);
  }

  clearRowSelected() {
    this.selected = [];
    this.allRowsSelected = false;
  }

  changeFilters() {
    this.clearRowSelected();
    this.fillData(0);
  }

  fillData(page: number = 0) {
    this.spinnerService.show();
    this.filters = this.filters.set("page", String(page));
    this.filters = this.filters.set("size", this.tableLimit.toString());

    this.tableService.getData(
      this.urlGet,
      this.filters,
      (response) => {
        if (response && response.content) {
          if (this.headerAtivacao) {
            this.hasErrors =
              response.content.filter((r) => r.status === "ERRO").length > 0;
          }
          this.datatablePagination.rowData = response.content || [];
          this.datatablePagination.totalElements = response.totalElements;
          this.datatablePagination.totalPages = response.totalPages;
          this.datatablePagination.currentPage = response.pageable.pageNumber;
          this.paginationService.setInfo(response);
        } else {
          this.datatablePagination.rowData = [];
          this.datatablePagination.totalElements = 0;
          this.datatablePagination.totalPages = 0;
          this.datatablePagination.currentPage = 0;
        }
        this.spinnerService.hide();
      },
      (_error) => {
        this.spinnerService.hide();
        this.datatablePagination.rowData = [];
        this.datatablePagination.totalElements = 0;
      }
    );
  }

  onSelect(e) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...e.selected);
    this.getSelected.emit(this.selected);
  }

  onSelectAll(e: any) {
    if (e.selected) {
      this.selected = [...this.datatablePagination.rowData];
      this.allRowsSelected = true;
    } else {
      this.clearRowSelected();
    }
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  onAction() {
    this.action.emit();
  }

  onView(row: any) {
    this.actionView.emit(row);
  }

  onChangeItemsPerPage(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    this.tableLimit = Number(selectElement.value);
    this.clearRowSelected();
    this.fillData(0);
  }

  onSecondaryAction(row: any) {
    getDialogCancel(this.dialogService, row, this.importacaoType, (result) => {
      this.spinnerService.show();
      if (result) {
        this.tableService.cancelLote(
          row.id,
          getImportacaoType(this.importacaoType).type,
          (_response) => {
            this.spinnerService.hide();
            this.notificationsService.success("Lote cancelado com sucesso!");
            this.ngOnInit();
          },
          (_error) => {
            this.spinnerService.hide();
            this.notificationsService.error("Erro ao cancelar lote!");
          }
        );
      } else {
        this.spinnerService.hide();
      }
    });
  }

  onShowSecondaryAction(value: any): boolean {
    if (this.isAtivacao) {
      return false;
    }

    const validStatuses = ["ABERTO", "CRIADO", "AGENDADO"];
    return value.status && validStatuses.includes(value.status);
  }

  openModal() {
    this.dialogService.open(ModalHelpComponent, {
      closeOnBackdropClick: false,
      closeOnEsc: false,
      context: {
        importacaoType: this.importacaoType,
      },
    });
  }

  openModalErro(event) {
    this.dialogService.open(ModalErroComponent, {
      context: {
        importacaoType: this.importacaoType,
        motivoStatus: (event.motivoStatus || "").replace(/; /g, "<br>"),
      },
      closeOnBackdropClick: false,
      closeOnEsc: false,
    });
  }

  hasError(row: any): boolean {
    const errorStatuses = new Set([
      "ERRO", "INVALIDO", "ERRO_CADASTRO",
      "ERRO_CONTA", "ERRO_CARTAO", "ERRO_ACESSO"
    ]);

    return errorStatuses.has(row.status);
  }


  downloadErrorReport() {
    if (this.actionDownloadError) {
      this.actionDownloadError.emit();
    }
  }
}
